<template>
  <BlackBoxToolCard :card-name="tr('Tumor Board')" :payload="payload"></BlackBoxToolCard>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
// Copyright (c) 2023 datma, inc.
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import BlackBoxToolCard from '../BlackBoxToolCard/BlackBoxToolCard.vue'
import getEnv from '@/utils/env'

const tr = (x) => x // inject('tr')
const baseUrl = getEnv('VUE_APP_TUMOR_BOARD_BASE_URL') || 'https://pathreport.dev.datma.com/tumor_board/mypatient/v1/'

const payload = {
  data: {},
  url: {
    baseUrl,
    method: 'GET',
    queryParams: {
      toolId: { key: 'toolId', required: true },
    },
  },
}

</script>

<style lang="scss" scoped></style>
